import React from 'react'
import {
  Stack,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
} from '@mui/material'
import EmployeeSelector from '../../pages/events/EmployeeSelector'

// Controlled-drug witness input shared by every CD event: a colleague looked
// up by name, or someone without an account (name + contact details). Value
// shape and helpers live in helpers/medicineWitness.js.
//
// The signed-in user is excluded by default - they are usually the person
// performing the action. Pass preventSelectingSelf={false} plus
// excludeUserIds when someone else is (e.g. the administering clinician on
// a record made on their behalf).
const WitnessPicker = ({
  value,
  onChange,
  label = 'Witnessed by',
  size = 'small',
  required = true,
  disabled = false,
  preventSelectingSelf = true,
  excludeUserIds = [],
  helperText,
}) => {
  const update = (patch) => onChange({ ...value, ...patch })

  return (
    <Stack gap={1.5}>
      <ToggleButtonGroup
        exclusive
        size="small"
        value={value.type}
        onChange={(e, type) => type && update({ type })}
        disabled={disabled}
      >
        <ToggleButton value="colleague">Colleague</ToggleButton>
        <ToggleButton value="external">Not a colleague</ToggleButton>
      </ToggleButtonGroup>
      {value.type === 'colleague' ? (
        <EmployeeSelector
          label={label}
          value={value.user}
          onChange={(e, user) => update({ user })}
          preventSelectingSelf={preventSelectingSelf}
          excludeUserIds={excludeUserIds}
          fullWidth
          size={size}
          required={required}
          disabled={disabled}
          helperText={helperText}
        />
      ) : (
        <>
          <TextField
            label="Witness name"
            size={size}
            value={value.name}
            onChange={(e) => update({ name: e.target.value })}
            required={required}
            disabled={disabled}
            autoComplete="off"
          />
          <TextField
            label="Witness email"
            type="email"
            size={size}
            value={value.email}
            onChange={(e) => update({ email: e.target.value })}
            required={required}
            disabled={disabled}
            autoComplete="off"
          />
          <TextField
            label="Witness phone"
            type="tel"
            size={size}
            value={value.phone}
            onChange={(e) => update({ phone: e.target.value })}
            required={required}
            disabled={disabled}
            autoComplete="off"
            helperText={helperText}
          />
        </>
      )}
    </Stack>
  )
}

export default WitnessPicker
